
export const gatherKeyData = (keyStr, data)=> {

	let type;
	let types = {};

	const capitalize = (str)=>{
		return str.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
	};

	try {
		data.map( item => {
			type = item.get(keyStr);

			if(!type) { return null;}
			type = type.toLocaleLowerCase();

			return types[type] = {
				"amount": (( types[type] && types[type].amount + 1 ) || 1),
				"name": type,
				"label": capitalize(type)
			}

		});
		return types;
	} catch (e) {
		return e;
	}
}

export const fetchFilters = (args)=> {
	const method = "GET";
	const headers = new Headers();
	const url = args.url;

	headers.append('Accept', 'application/json');

	let options = {
		headers,
		method
	};

	return fetch( url, options )
		.then( response=> {
// console.log("response Area Filters: " , response );
			if (response.ok) {
				return response.json();
			}
		})
		.then( json=>{
			return json;
		})
		.catch( error=> {
// console.warn("error : " , error);
			throw error;
		})

}



// WEBPACK FOOTER //
// ./src/js/api/filters.js